import axios from "axios";

import { BASEURL } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";

export function ApiFinance() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "finance/";
  return {
    //UNITS
    GetFinanceAccountDetail: (unitId) =>
      authAxios.get(url + "GetFinanceAccountDetail/" + unitId),
    UpdateUnitFinanceAccount: (record) =>
      authAxios.post(url + "UpdateUnitFinanceAccount", record),
    GetFinanceAccountsAndDimensions: () =>
      authAxios.get(url + "GetFinanceAccountsAndDimensions"),
    GetFinanceBankAccounts: (unitId) =>
      authAxios.get(url + "GetFinanceBankAccounts/" + unitId),

    //TRANSFER
    GetCashToAmanatTransferData: (unitId) =>
      authAxios.get(url + "GetCashToAmanatTransferData/" + unitId),
    GetTransactionDetails: (transNo) =>
      authAxios.get(url + "GetTransactionDetails/" + transNo),
    TransferCashinHandtoAmanat: (record) =>
      authAxios.post(url + "TransferCashinHandtoAmanat", record),
    TransferAmanatToCashInHand: (record) =>
      authAxios.post(url + "TransferAmanatToCashInHand", record, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    EditCashinHandtoAmanat: (record) =>
      authAxios.post(url + "EditCashinHandtoAmanat", record),
    ViewTransactionAttachment: (transNo) =>
      authAxios.get(url + "ViewTransactionAttachment/" + transNo, {
        responseType: "blob",
      }),
    GetTransferDataForNotification: (notificationId) =>
      authAxios.get(url + "GetTransferDataForNotification/" + notificationId),

    DeleteTransaction: (id) =>
      authAxios.delete(url + "DeleteTransaction/" + id),

    GetCashToAmanatTransactionsByDateAndAccount: (record) =>
      authAxios.post(
        url + "GetCashToAmanatTransactionsByDateAndAccount",
        record,
      ),
    GetInfaqTransactionsByDateAndAccount: (record) =>
      authAxios.post(url + "GetInfaqTransactionsByDateAndAccount", record),

    TransferNotificationAction: (formData) =>
      authAxios.post(url + "TransferNotificationAction", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),

    AddOtherIncome: (record) => authAxios.post(url + "AddOtherIncome", record),
    EditOtherIncome: (record) =>
      authAxios.post(url + "EditOtherIncome", record),
    AddOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(url + "AddOtherIncomeLoanFromMarkaz", record),
    GetOtherIncomeDataForNotification: (notificationId) =>
      authAxios.get(
        url + "GetOtherIncomeDataForNotification/" + notificationId,
      ),
    RequestModificationOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(
        url + "RequestModificationOtherIncomeLoanFromMarkaz",
        record,
      ),
    ApproveOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(url + "ApproveOtherIncomeLoanFromMarkaz", record),
    ApproveModificationOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(
        url + "ApproveModificationOtherIncomeLoanFromMarkaz",
        record,
      ),
    AddOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(url + "AddOtherIncomeTarbiatiCourseReimbursment", record),
    RequestModificationOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(
        url + "RequestModificationOtherIncomeTarbiatiCourseReimbursment",
        record,
      ),
    ApproveModificationOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(
        url + "ApproveModificationOtherIncomeTarbiatiCourseReimbursment",
        record,
      ),
    ApproveOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(
        url + "ApproveOtherIncomeTarbiatiCourseReimbursment",
        record,
      ),

    AddOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(url + "AddOtherIncomeHelpFromMuqamiTanzeem", record),
    RequestModificationOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(
        url + "RequestModificationOtherIncomeHelpFromMuqamiTanzeem",
        record,
      ),
    ApproveOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(url + "ApproveOtherIncomeHelpFromMuqamiTanzeem", record),

    ApproveModificationOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(
        url + "ApproveModificationOtherIncomeHelpFromMuqamiTanzeem",
        record,
      ),

    AddExpenseFromCashInHand: (record) =>
      authAxios.post(url + "AddExpenseFromCashInHand", record),
    GetHalqaShareCalculatedAmount: (unitId, date) =>
      authAxios.get(url + "GetHalqaShareCalculatedAmount/" + unitId + "/" + date),
    AddHalqaShareExpense: (record) =>
      authAxios.post(url + "AddHalqaShareExpense", record),
    ApproveHalqaShareExpense: (record) =>
      authAxios.post(url + "ApproveHalqaShareExpense", record),
    GetMarkazShareCalculatedAmount: (unitId, date) =>
      authAxios.get(url + "GetMarkazShareCalculatedAmount/" + unitId + "/" + date),
    MarkazShareTransfer: (record) =>
      authAxios.post(url + "MarkazShareTransfer", record),
    ApproveMarkazShareTransfer: (record) =>
      authAxios.post(url + "ApproveMarkazShareTransfer", record),
    EditExpense: (record) => authAxios.post(url + "EditExpense/", record),
    EditExpenseFromAmanat: (record) => authAxios.post(url + "EditExpenseFromAmanat", record),
    AddExpenseFromAmanat: (record) =>
      authAxios.post(url + "AddExpenseFromAmanat", record),
    ApproveExpenseFromAmanat: (record) =>
      authAxios.post(url + "ApproveExpenseFromAmanat", record),
    GetExpenseTransactions: (record) =>
      authAxios.post(url + "GetExpenseTransactions", record),
    DeleteExpense: (id) => authAxios.delete(url + "DeleteExpense/" + id),

    GetFinanceCategoryAccountsByCode: (type) =>
      authAxios.get(url + "GetFinanceCategoryAccountsByCode/" + type),
    GetVendorBankAccounts: () =>
      authAxios.get(url + "GetVendorBankAccounts"),
    GetVendorBankAccountsByCnic: (cnic) =>
      authAxios.get(url + "GetVendorBankAccountsByCnic", { params: { cnic } }),
    AddVendorBankAccount: (record) =>
      authAxios.post(url + "AddVendorBankAccount", record),
    UpdateVendorBankAccount: (record) =>
      authAxios.put(url + "UpdateVendorBankAccount", record),
    DeleteVendorBankAccount: (id) =>
      authAxios.delete(url + "DeleteVendorBankAccount", { params: { id } }),
  };
}
